import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "renderers", "actionOptions", "response", "aiSummaryConfig"];
import { extractSummary } from '../common/primitives';
import extractActions from './actions';
import { extractLinkIcon } from './icon';
import { extractAttachmentCount, extractChecklistProgress, extractCommentCount, extractCreatedBy, extractModifiedBy, extractProgrammingLanguage, extractSubscriberCount, extractViewCount, extractReactCount, extractVoteCount, extractSourceBranch, extractTargetBranch, extractDueOn, extractLocation, extractOwnedBy, extractAssignedTo, extractSubTasksProgress, extractStoryPoints, extractReadTime, extractSentOn, extractPersonAssignedToAsArray } from './utils';
import { extractPersonsUpdatedBy } from './collaboratorGroup';
import { extractPersonCreatedBy, extractTitle, extractDateUpdated, extractDateCreated, extractLink, extractPersonOwnedBy, extractAri } from '@atlaskit/link-extractors';
import extractPriority from './extract-priority';
import extractProviderIcon from './icon/extract-provider-icon';
import extractPreview from './extract-preview';
import extractState from './extract-state';
import { extractLatestCommit } from './latest-commit';
import { extractViewAction } from './actions/extract-view-action';
var extractFlexibleUiContext = function extractFlexibleUiContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = _ref.id,
    renderers = _ref.renderers,
    actionOptions = _ref.actionOptions,
    response = _ref.response,
    aiSummaryConfig = _ref.aiSummaryConfig,
    props = _objectWithoutProperties(_ref, _excluded);
  if (!response) {
    return undefined;
  }
  var data = response.data;
  var url = extractLink(data);
  return {
    // Use the original URL in edge cases, such as short links for AI summary and copy link actions.
    actions: extractActions(response, props.url, actionOptions, id, aiSummaryConfig),
    assignedToGroup: extractPersonAssignedToAsArray(data),
    attachmentCount: extractAttachmentCount(data),
    authorGroup: extractPersonCreatedBy(data),
    ownedByGroup: extractPersonOwnedBy(data),
    collaboratorGroup: extractPersonsUpdatedBy(data),
    commentCount: extractCommentCount(data),
    viewCount: extractViewCount(data),
    reactCount: extractReactCount(data),
    voteCount: extractVoteCount(data),
    checklistProgress: extractChecklistProgress(data),
    createdBy: extractCreatedBy(data),
    ownedBy: extractOwnedBy(data),
    assignedTo: extractAssignedTo(data),
    createdOn: extractDateCreated(data),
    dueOn: extractDueOn(data),
    viewAction: extractViewAction(data, actionOptions),
    latestCommit: extractLatestCommit(data),
    linkIcon: extractLinkIcon(response, renderers),
    location: extractLocation(data),
    modifiedBy: extractModifiedBy(data),
    modifiedOn: extractDateUpdated(data),
    preview: extractPreview(data),
    priority: extractPriority(data),
    provider: extractProviderIcon(data),
    programmingLanguage: extractProgrammingLanguage(data),
    readTime: extractReadTime(data),
    sentOn: extractSentOn(data),
    snippet: extractSummary(data) || undefined,
    // Explicitly set here to remove an empty string
    sourceBranch: extractSourceBranch(data),
    state: extractState(response, actionOptions, id),
    subscriberCount: extractSubscriberCount(data),
    subTasksProgress: extractSubTasksProgress(data),
    storyPoints: extractStoryPoints(data),
    targetBranch: extractTargetBranch(data),
    title: extractTitle(data) || url,
    url: url,
    ari: extractAri(data)
  };
};
export default extractFlexibleUiContext;